import { apdexType } from '@atlassiansox/analytics-web-client';
import track from 'debug/track';
import Analytics from 'lib/analytics';

export default new class Apdex {
  events = {};

  isInitialLoad = true;
  initialVisibilityHidden = document.visibilityState == 'hidden';
  initialUrl = window.location.href;

  _getEventKey(task, taskId) {
    return taskId ? `${task}:${taskId}` : task;
  }

  resetInitialState() {
    this.isInitialLoad = true;
    this.initialUrl = window.location.href;
  }

  start(options) {
    const { task, taskId } = options;
    const key = this._getEventKey(task, taskId);

    if (this.events[key]) {
      console.warn(`Apdex event "${key}" has already been started`);
      return;
    }

    this.events[key] = Object.assign({ startTime: Date.now() }, options);
    Analytics.startApdexEvent({ task, taskId });
  }

  stop(options) {
    const { task, taskId, type } = options;
    const key = this._getEventKey(task, taskId);
    const event = this.events[key];

    if (!event) {
      console.warn(`Apdex event "${key}" was never started`);
      return;
    }

    const isInitialLoad = type === apdexType.INITIAL_LOAD ||
      this.isInitialLoad && this.initialUrl == window.location.href;
    const label = isInitialLoad ? apdexType.INITIAL_LOAD : apdexType.TRANSITION;
    const property = (isInitialLoad && this.initialVisibilityHidden) ||
      document.visibilityState == 'hidden' ? 'hidden' : 'visible';

    const now = Date.now();
    const navigationStartDuration = now - window.performance.timing.navigationStart;
    const transitionDuration = now - event.startTime;
    const totalDuration = isInitialLoad ? navigationStartDuration : transitionDuration;

    track('apdex', task, label, property, totalDuration);

    Analytics.stopApdexEvent({
      task,
      taskId,
      type: label,
    })

    if (isInitialLoad) {
      track(
        'apdex',
        task,
        'timeSpentBeforeMeasure',
        property,
        navigationStartDuration - transitionDuration
      );

      this.isInitialLoad = false;
    }

    delete this.events[key];
  }

  cancel(options) {
    const { task, taskId, type } = options;
    const key = this._getEventKey(task, taskId);

    if (!this.events[key]) {
      console.warn(`Apdex event "${key}" was never started`);
      return;
    }

    delete this.events[key];
  }
}


// WEBPACK FOOTER //
// ./app/scripts/debug/apdex.js